const mediaQueryConfig = [
    "(min-width: 1920px)",
    "(max-width: 1920px) and (min-width: 1300px)",
    "(max-width: 1300px) and (min-width: 1080px)",
    "(max-width: 1080px) and (min-width: 880px)",
    "(max-width: 880px) and (min-width: 675px)",
    "(max-width: 675px) and (min-width: 414px)",
    "(max-width: 414px)"
]
export default mediaQueryConfig;